import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useContext,
} from "react";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIosNew";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FeedbackIcon from "@mui/icons-material/Feedback";
import LanguageIcon from "@mui/icons-material/Language";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExploreIcon from "@mui/icons-material/Explore";
import "../index.css";
import translations from "./translation";
import { ProductContext } from "../context/AppContext";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import FooterNav from "./Common_Components/FooterNav";
import axios from "axios";
import {
  buildPhoneNumber,
  DEFAULT_PHONE_COUNTRY,
  PHONE_COUNTRIES,
  extractPhoneParts,
} from "../utils/phoneCountries";

function Profile() {
  const navigate = useNavigate();
  const {
    username,
    notificationsByType,
    setNotificationsByType,
    refreshNotificationsByType,
  } = useContext(ProductContext);
  console.log("username:Profile", username);
  const timeout = useRef(null);
  const timeoutDuration = 60 * 60 * 1000; // 1 Hour
  const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
  const { Translate } = useContext(ProductContext);
  const localTranslations = translations[SelectLanguageLocal === "hindi" ? "hindi" : "english"];

  const [showCollegeModal, setShowCollegeModal] = useState(false);
  const [collegeCode, setCollegeCode] = useState("");
  const [modalLoading, setModalLoading] = useState(false);
  const [notificationTab, setNotificationTab] = useState("group");
  const [visibleCountByType, setVisibleCountByType] = useState({
    group: 8,
    individual: 8,
  });
  const [showNotifications, setShowNotifications] = useState(false);
  const [modalError, setModalError] = useState("");
  const [showProfileEdit, setShowProfileEdit] = useState(false);
  const [profileEmail, setProfileEmail] = useState("");
  const [profileBirthdate, setProfileBirthdate] = useState("");
  const [profilePhoneCountryCode, setProfilePhoneCountryCode] = useState(DEFAULT_PHONE_COUNTRY);
  const [profilePhoneNumber, setProfilePhoneNumber] = useState("");
  const [profileUpdateLoading, setProfileUpdateLoading] = useState(false);
  const [profileUpdateMessage, setProfileUpdateMessage] = useState("");
  const [profileUpdateError, setProfileUpdateError] = useState("");
  const [currentExamPassName, setCurrentExamPassName] = useState("");
  const [currentPlan, setCurrentPlan] = useState(null);
  const authToken = localStorage.getItem("AuthToken");
  const isReactNativeApp = typeof window !== "undefined" && !!window.ReactNativeWebView;

  // React Native app me Profile par current plan ka name aur date dikhana hai
  useEffect(() => {
    if (!isReactNativeApp || !authToken) return;

    const fetchCurrentPlan = async () => {
      const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${authToken}`,
      };
      try {
        const [subscriptionRes, plansRes] = await Promise.all([
          axios.get("https://api.japaking.online/api/user-subscription", { headers }),
          axios.get("https://api.japaking.online/api/subscription-plan", { headers }),
        ]);

        const userPlans = subscriptionRes.data?.message?.plan;
        if (!Array.isArray(userPlans) || userPlans.length === 0) {
          setCurrentPlan(null);
          return;
        }

        // Plans.js wala logic: pehle backend Activity_Status, warna date range
        const now = new Date();
        const getActivity = (p) => (p.Activity_Status ? String(p.Activity_Status).toLowerCase() : "");
        const sortedPlans = [...userPlans].sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
        const activeSub =
          sortedPlans.find((p) => ["active", "trial", "trail"].includes(getActivity(p))) ||
          sortedPlans.find((p) => new Date(p.start_date) <= now && new Date(p.end_date) >= now && p.status === "active");

        if (!activeSub) {
          setCurrentPlan(null);
          return;
        }

        const allPlans = plansRes.data?.message?.plans || [];
        const planInfo = allPlans.find((p) => p.id === activeSub.subscription_plan_id);
        setCurrentPlan({
          name: planInfo ? planInfo.name : "Active Plan",
          startDate: activeSub.start_date,
          endDate: activeSub.end_date,
        });
      } catch (error) {
        console.error("Error fetching current plan:", error);
        setCurrentPlan(null);
      }
    };

    fetchCurrentPlan();
  }, [isReactNativeApp, authToken]);

  const formatPlanDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return "";
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${dd}/${mm}/${yyyy}`;
  };

  const logout = useCallback(() => {
    localStorage.clear();
    navigate('/login', { replace: true });
    window.history.pushState(null, '', window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, '', window.location.href);
    };
  }, [navigate]);

  const resetTimeout = useCallback(() => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(logout, timeoutDuration); 
  }, [logout, timeoutDuration]);

  useEffect(() => {
    window.addEventListener('mousemove', resetTimeout);
    window.addEventListener('keypress', resetTimeout);

    timeout.current = setTimeout(logout, timeoutDuration); 

    return () => {
      window.removeEventListener('mousemove', resetTimeout);
      window.removeEventListener('keypress', resetTimeout);
      clearTimeout(timeout.current); // Clean up the timeout on component unmount
    };
  }, [resetTimeout, logout, timeoutDuration]);

  useEffect(() => {
    refreshNotificationsByType("group");
    refreshNotificationsByType("individual");
    setVisibleCountByType((prev) => ({
      ...prev,
      group: 8,
      individual: 8,
    }));
  }, [refreshNotificationsByType]);

  useEffect(() => {
    const details = username?.message?.userDetails;
    if (!details) return;
    setProfileEmail(details?.email || "");
    setProfileBirthdate(details?.birthdate || "");
    const phoneParts = extractPhoneParts(details?.phone_number || "");
    setProfilePhoneCountryCode(phoneParts.countryCode || DEFAULT_PHONE_COUNTRY);
    setProfilePhoneNumber(phoneParts.localNumber || "");
  }, [username]);

  useEffect(() => {
    const fetchCurrentExamPassType = async () => {
      const currentExamPassIdRaw = username?.message?.userDetails?.current_exam_pass_id;
      const examPassIds = Array.isArray(currentExamPassIdRaw)
        ? currentExamPassIdRaw.filter(Boolean)
        : currentExamPassIdRaw
          ? [currentExamPassIdRaw]
          : [];

      if (!examPassIds.length || !authToken) {
        setCurrentExamPassName("");
        return;
      }

      try {
        const examPassIdsPath = examPassIds.join(",");
        const response = await axios.get(
          `https://api.japaking.online/api/current-exam-pass-types/${examPassIdsPath}`,
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        const examPassTypes = response?.data?.message?.currentExamPassTypes;
        const singleExamPassType = response?.data?.message?.currentExamPassType;

        if (Array.isArray(examPassTypes) && examPassTypes.length) {
          setCurrentExamPassName(
            examPassTypes
              .map((item) => item?.exam_pass_name)
              .filter(Boolean)
              .join(", ")
          );
        } else if (singleExamPassType?.exam_pass_name) {
          setCurrentExamPassName(singleExamPassType.exam_pass_name);
        } else {
          setCurrentExamPassName("");
        }
      } catch (error) {
        console.error("Error fetching current exam pass type:", error);
        setCurrentExamPassName("");
      }
    };

    fetchCurrentExamPassType();
  }, [username, authToken]);

  const handleMarkAsRead = async (notificationId) => {
    try {
      await axios.patch(`https://api.japaking.online/api/notifications/${notificationId}/read`, {}, {
        headers: { Authorization: `Bearer ${authToken}` }
      });
      setNotificationsByType((prev) => {
        const markRead = (items) =>
          items.map((n) =>
            n.notification_id === notificationId ? { ...n, is_read: true } : n
          );
        return {
          group: markRead(prev.group),
          individual: markRead(prev.individual),
        };
      });
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  const handleUpdateProfileFields = async () => {
    setProfileUpdateError("");
    setProfileUpdateMessage("");

    if (!profileEmail?.trim()) {
      setProfileUpdateError("Email is required.");
      return;
    }

    const formattedPhoneNumber = buildPhoneNumber(
      profilePhoneNumber,
      profilePhoneCountryCode
    );

    setProfileUpdateLoading(true);
    try {
      const response = await axios.patch(
        "https://api.japaking.online/api/users/profile-fields",
        {
          birthdate: profileBirthdate || null,
          email: profileEmail.trim(),
          phone_number: formattedPhoneNumber || null,
        },
        {
          headers: {
            Accept: "application/json, text/plain, */*",
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success) {
        setProfileUpdateMessage("Profile updated successfully. Please re-login to refresh profile details.");
      } else {
        setProfileUpdateError(response?.data?.message || "Failed to update profile.");
      }
    } catch (error) {
      setProfileUpdateError(
        error?.response?.data?.message || "An error occurred while updating profile."
      );
    } finally {
      setProfileUpdateLoading(false);
    }
  };

  const handleShowCollegeModal = () => setShowCollegeModal(true);
  const handleCloseCollegeModal = () => {
    setShowCollegeModal(false);
    setCollegeCode("");
    setModalError("");
  };

  const handleConnectSchool = async () => {
    if (!collegeCode.trim()) {
      setModalError("Please enter a college code.");
      return;
    }
    setModalLoading(true);
    setModalError("");
    try {
      const userId = username?.message?.userDetails?.user_id;
      if (!userId) {
        throw new Error("User ID not found. Please log in again.");
      }
      const response = await axios.patch(
        `https://api.japaking.online/api/users/college-code?userId=${userId}`,
        { college_code: collegeCode.trim() },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data?.success) {
        alert("School connected successfully! Please log in again to see the changes.");
        handleCloseCollegeModal();
        logout();
      } else {
        throw new Error(response.data?.message || "Failed to connect school.");
      }
    } catch (error) {
      console.error("Failed to connect school:", error);
      setModalError(error.response?.data?.message || error.message || "An error occurred.");
    } finally {
      setModalLoading(false);
    }
  };

  const unreadGroupCount = notificationsByType.group.filter(n => !n.is_read).length;
  const unreadIndividualCount = notificationsByType.individual.filter(n => !n.is_read).length;
  const unreadCount = unreadGroupCount + unreadIndividualCount;
  const activeNotifications = notificationsByType[notificationTab] || [];
  const activeVisibleCount = visibleCountByType[notificationTab] || 8;
  const visibleNotifications = activeNotifications.slice(0, activeVisibleCount);
  const hasMoreNotifications = activeNotifications.length > activeVisibleCount;

  const getCollegeName = (user) =>
    user?.college?.college_name ||
    user?.college?.name ||
    user?.college_name ||
    user?.college ||
    "";

  const getSenderMeta = (notification) => {
    const sender = notification?.sender_user || {};
    const senderRole = (sender?.role?.role_name || "").toLowerCase();
    const roleName = sender?.role?.role_name || "Unknown";
    const isStudent = senderRole.includes("student") || sender?.role_id === 1;
    const schoolName = getCollegeName(sender);
    const phoneNumber = sender?.phone_number || "";
    const isErishAdmin =
      senderRole.includes("erish admin") ||
      senderRole.includes("admin") ||
      sender?.role_id === 6;

    if (isStudent) {
      return {
        title: sender?.name || "Student",
        roleLine: `Role: ${roleName}`,
        subtitle: `School: ${schoolName || "null"}`,
        extra: phoneNumber ? `Phone: ${phoneNumber}` : "",
      };
    }

    if (isErishAdmin) {
      return {
        title: sender?.name || "Erish Admin",
        roleLine: `Role: ${roleName}`,
        subtitle: `College: ${schoolName || "null"}`,
        extra: "",
      };
    }

    return {
      title: sender?.name || "Sender",
      roleLine: `Role: ${roleName}`,
      subtitle: `College: ${schoolName || "null"}`,
      extra: sender?.role?.role_name ? `Role: ${sender.role.role_name}` : "",
    };
  };

  const buildChatLink = (notification) => {
    const sender = notification?.sender_user || {};
    const receiver = notification?.receiver_user || {};
    const chatType = notification?.chat_type || "individual";

    if (chatType === "group") {
      return `/chat-with-staff?chatType=group&chatId=${notification?.chat_id || notification?.related_id || ""}`;
    }

    const senderRole = (sender?.role?.role_name || "").toLowerCase();
    const receiverRole = (receiver?.role?.role_name || "").toLowerCase();
    const senderIsStudent = senderRole.includes("student") || sender?.role_id === 1;
    const receiverIsStudent = receiverRole.includes("student") || receiver?.role_id === 1;
    const staffUser = !senderIsStudent ? sender : !receiverIsStudent ? receiver : receiver;
    const targetId = staffUser?.user_id || receiver?.user_id || sender?.user_id || "";
    const targetStaff = staffUser?.college_id ? "college" : "erish";

    return `/chat-with-staff?chatType=individual&staffTarget=${targetStaff}&participantId=${targetId}`;
  };

  const handleNotificationOpen = async (notification) => {
    try {
      if (!notification?.is_read) {
        await handleMarkAsRead(notification.notification_id);
      }
    } finally {
      navigate(buildChatLink(notification));
      setShowNotifications(false);
    }
  };

  return (
    <div className="Profile_Design_Main_Div_11">
      <div className="header_inner">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ArrowBackIosIcon
                onClick={() => navigate(-1)}
                className="icon_1"
              />
              <h2>{Translate?.message?.data?.profile || "Profile"}</h2>
              <ChatBubbleOutlineIcon
                onClick={() => navigate('/chat-with-staff')}
                className="logo_1"
                style={{ cursor: 'pointer', color: '#ffc0cb' }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="profile-container">
        {/* Header Section */}

        {/* <div className="profile-info">
          <div className="profile-avatar">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/profile.jpg`}
              alt="Profile Avatar"
              className="avatar-image"
            />
          </div>
          <div className="profile-details">
            <p className="profile-name">
              {username?.message?.userDetails?.name}n h nb  bh n nbh hnb h hcffdxfcgfc n h b gcgfxgxnn jbjh hvgh  hgvhn v fg hvgh
            </p>
            <p className="profile-email">
              {username?.message?.userDetails?.email}
            </p>
            <p className="profile-user-id">
              User_Id: {username?.message?.userDetails?.user_id}
            </p>
          </div>
          <EditIcon className="edit-icon" />
        </div> */}
        <div className="">
          <div className="row">
            <div className="col col-sm-12 col-md-12">
              <div className="image_profile-left">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/profile.jpg`}
                  alt="Profile Avatar"
                  className="avatar-image1"
                />
              </div>

              <div className="profile-details">
                <p className="profile-name">
                  {username?.message?.userDetails?.name}
                </p>
                <p className="profile-email">
                  {username?.message?.userDetails?.email}
                </p>
                <p className="profile-user-id">
                  User_Id: {username?.message?.userDetails?.user_id}
                </p>
                <p className="profile-user-id">
                  <strong>Account Status:</strong> {username?.message?.userDetails?.account_status}
                </p>
                <p className="profile-user-id">
                  <strong>Current Exam Passed:</strong>{" "}
                  {currentExamPassName || "Not selected"}
                </p>
                {isReactNativeApp && (
                  <>
                    <p className="profile-user-id">
                      <strong>Plan Name:</strong>{" "}
                      {currentPlan?.name || "No active plan"}
                    </p>
                    {currentPlan && (
                      <p className="profile-user-id">
                        <strong>Plan Date:</strong>{" "}
                        {formatPlanDate(currentPlan.startDate)} - {formatPlanDate(currentPlan.endDate)}
                      </p>
                    )}
                  </>
                )}
              </div>
              <div className="profile_edit_icon" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <div style={{ position: 'relative', marginBottom: '15px' }}>
                  <div style={{ cursor: 'pointer' }} onClick={() => setShowNotifications(!showNotifications)}>
                    <NotificationsIcon className="edit-icon" />
                    {unreadCount > 0 && (
                      <span style={{
                        position: 'absolute',
                        top: '-8px',
                        right: '-8px',
                        backgroundColor: 'red',
                        color: 'white',
                        borderRadius: '50%',
                        padding: '2px 6px',
                        fontSize: '10px',
                        fontWeight: 'bold'
                      }}>
                        {unreadCount}
                      </span>
                    )}
                  </div>
                  {showNotifications && (
                    <div style={{
                      position: 'absolute',
                      top: '35px',
                      right: '0',
                      width: '300px',
                      maxHeight: '520px',
                      overflow: 'hidden',
                      backgroundColor: 'white',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      zIndex: 1000,
                      padding: '10px',
                      textAlign: 'left'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>
                        <h6 style={{ margin: 0, fontWeight: 'bold' }}>Notifications</h6>
                        <span style={{ cursor: 'pointer', fontSize: '20px', lineHeight: '1' }} onClick={() => setShowNotifications(false)}>&times;</span>
                      </div>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', padding: '8px 0 12px' }}>
                        <button
                          style={{
                            border: notificationTab === "group" ? 'none' : '1px solid rgba(67, 97, 238, 0.2)',
                            background: notificationTab === "group"
                              ? 'linear-gradient(135deg, #4361ee, #3f37c9)'
                              : 'white',
                            color: notificationTab === "group" ? 'white' : '#2b2d42',
                            borderRadius: '10px',
                            padding: '8px 10px',
                            fontWeight: 600,
                            fontSize: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '8px'
                          }}
                          onClick={() => {
                            setNotificationTab("group");
                            refreshNotificationsByType("group");
                          }}
                        >
                          Group
                          <span style={{
                            background: notificationTab === "group"
                              ? 'rgba(255,255,255,0.2)'
                              : 'rgba(0,0,0,0.08)',
                            padding: '2px 8px',
                            borderRadius: '999px',
                            fontSize: '11px',
                            fontWeight: 700
                          }}>
                            {unreadGroupCount}
                          </span>
                        </button>
                        <button
                          style={{
                            border: notificationTab === "individual" ? 'none' : '1px solid rgba(67, 97, 238, 0.2)',
                            background: notificationTab === "individual"
                              ? 'linear-gradient(135deg, #4361ee, #3f37c9)'
                              : 'white',
                            color: notificationTab === "individual" ? 'white' : '#2b2d42',
                            borderRadius: '10px',
                            padding: '8px 10px',
                            fontWeight: 600,
                            fontSize: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '8px'
                          }}
                          onClick={() => {
                            setNotificationTab("individual");
                            refreshNotificationsByType("individual");
                          }}
                        >
                          Individual
                          <span style={{
                            background: notificationTab === "individual"
                              ? 'rgba(255,255,255,0.2)'
                              : 'rgba(0,0,0,0.08)',
                            padding: '2px 8px',
                            borderRadius: '999px',
                            fontSize: '11px',
                            fontWeight: 700
                          }}>
                            {unreadIndividualCount}
                          </span>
                        </button>
                      </div>
                      <div style={{ maxHeight: '430px', overflowY: 'auto', paddingRight: '4px' }}>
                        {activeNotifications.length === 0 ? (
                          <p className="text-center text-muted" style={{ fontSize: '14px', margin: '10px 0' }}>
                            No {notificationTab} notifications
                          </p>
                        ) : (
                          visibleNotifications.map(notif => (
                            <div
                              key={notif.notification_id}
                              className={`p-2 mb-2 border rounded ${notif.is_read ? 'bg-light' : 'bg-white'}`}
                              style={{
                                borderLeft: notif.is_read ? '1px solid #dee2e6' : '4px solid #ffc0cb',
                                fontSize: '13px',
                                cursor: 'pointer',
                              }}
                              onClick={() => handleNotificationOpen(notif)}
                            >
                              <div className="mb-1" style={{ fontWeight: 600 }}>
                                {notif.message}
                              </div>
                              <div style={{ fontSize: '12px', color: '#555', lineHeight: 1.4 }}>
                                {(() => {
                                  const senderMeta = getSenderMeta(notif);
                                  return (
                                    <>
                                      <div><strong>Sent by:</strong> {senderMeta.title}</div>
                                      <div>{senderMeta.roleLine}</div>
                                      <div>{senderMeta.subtitle}</div>
                                      {senderMeta.extra ? <div>{senderMeta.extra}</div> : null}
                                    </>
                                  );
                                })()}
                              </div>
                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <small className="text-muted" style={{ fontSize: '11px' }}>{new Date(notif.created_at).toLocaleString()}</small>
                                {!notif.is_read && (
                                  <button
                                    className="btn btn-link btn-sm p-0 text-decoration-none"
                                    style={{ fontSize: '11px' }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleMarkAsRead(notif.notification_id);
                                    }}
                                  >
                                    Mark as Read
                                  </button>
                                )}
                              </div>
                            </div>
                          ))
                        )}
                        {hasMoreNotifications && (
                          <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0 2px' }}>
                            <button
                              className="btn btn-sm btn-outline-primary"
                              onClick={() =>
                                setVisibleCountByType((prev) => ({
                                  ...prev,
                                  [notificationTab]: prev[notificationTab] + 8,
                                }))
                              }
                            >
                              Load more
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div
                  style={{ cursor: "pointer", zIndex: 10, padding: "5px", margin: "-5px" }}
                  onClick={() => {
                    setShowProfileEdit((prev) => !prev);
                    setProfileUpdateError("");
                    setProfileUpdateMessage("");
                  }}
                >
                  <EditIcon className="edit-icon" />
                </div>
                {!(username?.message?.userDetails?.college_id) && (
                  <button 
                    onClick={handleShowCollegeModal} 
                    className="btn btn-sm btn-primary mt-2"
                    style={{ fontSize: '12px', borderRadius: '20px', padding: '5px 15px' }}
                  >
                    Connect (College)
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            marginTop: "16px",
            padding: "16px",
            borderRadius: "12px",
            border: "1px solid #e8e8e8",
            backgroundColor: "#fff",
            textAlign: "left",
          }}
        >
          <h5 style={{ marginBottom: "14px" }}>Update Profile Fields</h5>
          <div className="row">
            <div className="col-12 mb-3">
              <label style={{ fontWeight: 600, marginBottom: "6px" }}>Birthdate</label>
              <input
                type="date"
                className="form-control"
                value={profileBirthdate || ""}
                onChange={(e) => setProfileBirthdate(e.target.value)}
                disabled={!showProfileEdit}
              />
            </div>
            <div className="col-12 mb-3">
              <label style={{ fontWeight: 600, marginBottom: "6px" }}>Email</label>
              <input
                type="email"
                className="form-control"
                value={profileEmail}
                onChange={(e) => setProfileEmail(e.target.value)}
                placeholder="Enter email"
                disabled={!showProfileEdit}
              />
            </div>
            <div className="col-12 mb-3">
              <label style={{ fontWeight: 600, marginBottom: "6px" }}>Phone Number</label>
              <div className="d-flex" style={{ gap: "8px" }}>
                <select
                  className="form-control"
                  style={{ width: "auto", minWidth: "100px", maxWidth: "140px" }}
                  value={profilePhoneCountryCode}
                  onChange={(e) => setProfilePhoneCountryCode(e.target.value)}
                  disabled={!showProfileEdit}
                >
                  {PHONE_COUNTRIES.map((country) => (
                    <option key={country.code} value={country.code}>
                      {country.label}
                    </option>
                  ))}
                </select>
                <input
                  type="text"
                  className="form-control"
                  style={{ flex: 1 }}
                  value={profilePhoneNumber}
                  onChange={(e) => setProfilePhoneNumber(e.target.value)}
                  placeholder="Enter phone number"
                  disabled={!showProfileEdit}
                />
              </div>
            </div>
          </div>
          {profileUpdateError && (
            <Alert variant="danger" className="mt-2 mb-2">
              {profileUpdateError}
            </Alert>
          )}
          {profileUpdateMessage && (
            <Alert variant="success" className="mt-2 mb-2">
              {profileUpdateMessage}
            </Alert>
          )}
          {showProfileEdit && (
            <button
              type="button"
              className="btn btn-primary w-100 mt-2 py-2"
              onClick={handleUpdateProfileFields}
              disabled={profileUpdateLoading}
              style={{ borderRadius: "8px", fontWeight: "600" }}
            >
              {profileUpdateLoading ? "Updating..." : "Update Profile"}
            </button>
          )}
        </div>

        {/* Menu Options */}
        <div className="profile-menu">
          <div className="menu">
            <div onClick={() => navigate("/learning-journey")} className="menu-item">
              <ExploreIcon className="menu-icon" />
              <span className="menu-text">{localTranslations?.LessonList || Translate?.message?.data?.LessonList || "Lesson list"}</span>
              <ChevronRightIcon />
            </div>
          </div>
          <div className="menu">
            <div onClick={() => navigate("/Statistics")} className="menu-item">
              <AssignmentIcon className="menu-icon" />
              <span className="menu-text">{Translate?.message?.data?.staticts || "Staticts"}</span>
              <ChevronRightIcon />
            </div>
          </div>
          <div className="menu">
            <div onClick={() => navigate("/feedback")} className="menu-item">
              <FeedbackIcon className="menu-icon" />
                <span className="menu-text">{Translate?.message?.data?.feedback || "Feedback"}</span>
              <ChevronRightIcon />
            </div>
          </div>
          <div className="menu">
            <div onClick={() => navigate("/language")} className="menu-item">
              <LanguageIcon className="menu-icon" />       
                <span className="menu-text">{Translate?.message?.data?.language || "Language"}</span>         
              <ChevronRightIcon />
            </div>
          </div>
          <div className="menu">
            <div onClick={() => navigate("/chat-with-staff")} className="menu-item">
              <ChatBubbleOutlineIcon className="menu-icon" />
              <span className="menu-text">Chat With Staff</span>
              <ChevronRightIcon />
            </div>
          </div>
          <div className="menu-item logout" onClick={logout}>
            <ExitToAppIcon className="menu-icon" />
              <div className="menu-text">{Translate?.message?.data?.logout || "Logout"}</div>
          </div>
        </div>
      </div>
      {/* Footer Navigation */}
      {/* Footer Section */}
      <FooterNav authToken={authToken} translate={Translate} />
      <Modal show={showCollegeModal} onHide={handleCloseCollegeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Connect to your (School/College)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="collegeCode" className="mb-3">
              <Form.Label>College Code</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your college code"
                value={collegeCode}
                onChange={(e) => setCollegeCode(e.target.value)}
                autoFocus
              />
            </Form.Group>
            {modalError && <Alert variant="danger">{modalError}</Alert>}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseCollegeModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleConnectSchool} disabled={modalLoading}>
            {modalLoading ? 'Connecting...' : 'Connect'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Profile;
